import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LmsModalFrameComponent, NumbersOnlyDirective } from '@lmsSharedUI';

import { AppUtilityService } from '../app-utility.service';
import { ClientSearchModel } from '../core/models/client-search.model';

@Component({
  selector: 'app-employment-dialog',
  templateUrl: './employment-dialog.component.html',
  styleUrls: ['./employment-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LmsModalFrameComponent, NumbersOnlyDirective ],
})
export class EmploymentDialogComponent {
  clientSearchModel: ClientSearchModel = new ClientSearchModel();
  userName: any = localStorage.getItem('username');

  confirmedForm = this.fb.group({
    empConfirmed: [false, Validators.requiredTrue],
    contactPersonName: ['', []],
    contactNumber: ['', []]
  });

  constructor(
    private fb: FormBuilder,
    public global_utility: AppUtilityService,
    public modalRef: MdbModalRef<EmploymentDialogComponent>
  ) {
    this.confirmedForm.get('empConfirmed')?.valueChanges.subscribe(isConfirmed => {
      if (isConfirmed) {
        this.confirmedForm.get('contactPersonName')?.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(100)]);
        this.confirmedForm.get('contactNumber')?.setValidators([Validators.required, Validators.pattern('^[0-9]{10}$')]);
      } else {
        this.confirmedForm.get('contactPersonName')?.clearValidators();
        this.confirmedForm.get('contactNumber')?.clearValidators();
      }
      this.confirmedForm.get('contactPersonName')?.updateValueAndValidity();
      this.confirmedForm.get('contactNumber')?.updateValueAndValidity();
    });
  }

  onConfirmationChange() {
    if (!this.confirmedForm.get('empConfirmed')?.value) {
      this.confirmedForm.reset();
    }
  }

  isFormValid(): boolean {
    if (!this.confirmedForm.get('empConfirmed')?.value) {
      return true;
    }
    return this.confirmedForm.valid;
  }

  close() {
    this.modalRef.close();
  }

  save() {
    if (this.confirmedForm.get('empConfirmed')?.value) {
      if (!this.confirmedForm.get('contactPersonName')?.value) {
        this.global_utility.warning('Please enter the contact person\'s name and surname.', 'Employment Confirmation Required');
        return;
      }
      if (!this.confirmedForm.get('contactNumber')?.value) {
        this.global_utility.warning('Please enter the contact person\'s number.', 'Employment Confirmation Required');
        return;
      }
      if (!this.confirmedForm.get('contactNumber')?.valid) {
        this.global_utility.warning('Please enter a valid 10-digit contact number.', 'Invalid Contact Number');
        return;
      }
    }

    if (!this.confirmedForm.value || !this.confirmedForm.value.empConfirmed) {
      this.global_utility.info('Are you sure you want to continue without confirming employment?', 'Employment');
    }

    return this.modalRef.close(this.confirmedForm.value);
  }
}
